import React, {VoidFunctionComponent} from "react";
import s from "./CourseOverview.module.scss";
import {CourseLessonProgress} from "./courseLessonProgress/CourseLessonProgress";
import {CourseSummary} from "./courseSummary/CourseSummary";
import {CourseTeachers} from "./courseTeachers/CourseTeachers";
import {CourseOverviewListSection} from "./courseOverviewListSection/CourseOverviewListSection";
import {courseOverviewConfig} from "../../config/course-overview";
import {isUndefined} from "../../util/is-type";
import ILessonDetail from "../../models/view/common/ILessonDetail";

export interface ICourseOverviewProps {
  courseId: number;
  isOverviewOpen: boolean,
  detailsOfLessons?: ILessonDetail[],
}

export const CourseOverview: VoidFunctionComponent<ICourseOverviewProps> = ({courseId, isOverviewOpen, detailsOfLessons}) => {

  const courseOverview = courseOverviewConfig[courseId];

  if (isUndefined(courseOverview) || isUndefined(detailsOfLessons) || detailsOfLessons.length === 0){
    return null;
  }

  const baseClass = s.courseOverview;
  const activeClass = (isOverviewOpen ? s.active : '');
  const useClassNames = [baseClass, activeClass].join(' ');
  const totalLessons = detailsOfLessons.length;
  const completedLessons = detailsOfLessons.filter(lesson => lesson.isComplete === true).length;
  const incompleteLessons = totalLessons - completedLessons;

  return (
    <aside className={useClassNames}>
      <h2>Course Overview</h2>
      <CourseLessonProgress
        courseId={courseId}
        totalLessons={totalLessons}
        completed={completedLessons}
        incomplete={incompleteLessons}
        detailsOfLessons={detailsOfLessons}
      />
      <CourseSummary
        summary={courseOverview.summary}
        lessonFeatures={courseOverview.lessonFeatures}
        organizationMethod={courseOverview.organizationMethod}
      />
      <CourseTeachers teachers={courseOverview.teachers}/>
      <div className={s.listSections}>
        <CourseOverviewListSection title={"What you'll learn"} items={courseOverview.topics ?? []} />
        <CourseOverviewListSection title={"What you should already\u202fknow"} items={courseOverview.recommendedPreparation ?? []} />
      </div>
    </aside>
  );
}

